import { MonthEvent } from '@/lib/types';
import { client } from '../index';

const self = {

    async addEvent(evt: MonthEvent){

        console.log(evt);
        
        const response = await client.post('/misc/calendar/month', { ...evt });
        return response.data;

    },
    async editEvent(month_id: number, evt: MonthEvent){

        console.log(evt);
        
        const response = await client.post(`/misc/calendar/${evt.event_id!}`, { month_id, ...evt });
        return response.data;

    },
    async deleteEvent(id: string){

        const response = await client.delete(`/misc/calendar/event/${id}`)
        return response.data;

    },

    async getCurrentMonth(){

        const response = await client.get('/misc/calendar/month')
        return response.data;

    }

}

export default self;
